import _ from 'lodash';
import { i18n } from './i18n';
import { request } from 'beans-admin-plugin';
import pluralize from 'pluralize';
import { modelData, getLabel } from '@/custom_models_extend';

const components = {
  id: function() {
    return {
      renderCell: {
        component: 'input',
        props: {
          disabled: true
        }
      }
    }
  },
  type: function({ v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`model.${modelData[value]['element']}`), value: value }))
        }
      }
    }
  },
  attached: function({ v }) {
    let props = {}

    if (v.extra) {
      if (v.extra.accept) {
        props.accept = v.extra.accept
      }
      if (v.extra.type) {
        props.type = v.extra.type
      }
      if (v.extra.limit) {
        props.limit = v.extra.limit
      }
      if (v.extra.size) {
        props.size = v.extra.size
      }
    }

    return {
      renderCell: {
        component: 'upload',
        props: props
      }
    }
  },
  belongsTo: function({ v, data }) {
    const requestUrl = `/${pluralize(_.map(v.extra.model_name.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`

    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: (data[v.extra.foreign_key] && data[v.extra.association_name]) ? [{ label: getLabel({ item: data[v.extra.association_name], v }), value: data[v.extra.foreign_key] }] : [],
          xRemotePreload: async () => {
            const { data } = await request.get(requestUrl, { per_page: 100 });
            return data.map(item => ({ value: item.id, label: getLabel({ item, v }) }));
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get(requestUrl, { keyword });
            return data.map(item => ({ value: item.id, label: getLabel({ item, v }) }));
          }
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    }
  },
  hasMany: function({ v, data }) {
    const requestUrl = `/${pluralize(_.map(v.extra.model_name.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`

    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          multiple: true,
          options: _.map(data[v.extra.association_name], (item) => ({ label: getLabel({ item, v }), value: item.id })),
          xRemotePreload: async () => {
            const { data } = await request.get(requestUrl, { per_page: 100 });
            return data.map(item => ({ value: item.id, label: getLabel({ item, v }) }));
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get(requestUrl, { keyword });
            return data.map(item => ({ value: item.id, label: getLabel({ item, v }) }));
          }
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    }
  },
  enum: function({ k, v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: _.map(modelData[v.model_name]['enum'][pluralize(k)], (value) => ({ label: i18n.t(`${modelData[v.model_name]['element']}.${_.camelCase(pluralize(k))}.${value}`), value: value }))
        }
      }
    }
  },
  string: function() {
    return {
      renderCell: {
        component: 'input'
      }
    }
  },
  integer: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  decimal: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  float: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  text: function () {
    return {
      renderCell: {
        component: 'textarea',
      }
    }
  },
  boolean: function () {
    return {
      renderCell: {
        component: 'switch',
      }
    }
  },
  date: function () {
    return {
      renderCell: {
        component: 'datePicker',
        props: {
          valueFormat: 'yyyy-MM-dd'
        }
      }
    }
  },
  time: function () {
    return {
      renderCell: {
        component: 'timePicker',
      }
    }
  },
  datetime: function () {
    return {
      renderCell: {
        component: 'dateTimePicker',
      }
    }
  },
  tag: function() {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          multiple: true,
          allowCreate: true,
          xRemotePreload: async () => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { per_page: 100 })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { keyword })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          }
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    }
  },
}

export default function(columns, data) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (v.column_type && components[_.camelCase(v.column_type)]) {
      hash[k] = _.merge({
        prop: v.prop || k,
        label: i18n.t(`${modelData[v.model_name]['element']}.${_.camelCase(k)}`),
      }, components[_.camelCase(v.column_type)]({ k, v, data }))
    } else {
      console.error(`admin_entities对应文件未生成属性：${k}`)
    }
  })

  return hash
}
